import { useState, useCallback, createContext } from 'react';

export interface IFinCalcSpcContext {
  isFinCalcSpcOpen: boolean;
  setIsFinCalcSpcOpen: (isFinCalcSpcOpen: boolean) => void;
  widgetInstance: any;
  setWidgetInstance: (instance: any) => void;
}

export const FinCalcSpcContext = createContext<IFinCalcSpcContext>({
  isFinCalcSpcOpen: false,
  setIsFinCalcSpcOpen: () => null,
  widgetInstance: null,
  setWidgetInstance: () => null,
});

export const getFinCalcSpcContextValue: () => IFinCalcSpcContext = () => {
  const [isFinCalcSpcOpen, setOpen] = useState<boolean>(false);
  const [widgetInstance, setWidgetInstance] = useState(null);

  const setIsFinCalcSpcOpen = useCallback(
    (shouldOpen: boolean) => {
      setOpen(shouldOpen);
    },
    [isFinCalcSpcOpen],
  );

  return { isFinCalcSpcOpen, setIsFinCalcSpcOpen, widgetInstance, setWidgetInstance };
};
